.LevelBadge {
    position: relative;
    aspect-ratio: 1/1;

    .image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .hidden {
        opacity: 0;
        transition: opacity 1s linear;
    }

    .placeholder {
        transform: scale(1.05);
    }
}

.shiny {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
    inset: 0;
    mask-size: contain;
    mask-position: center;
    mask-repeat: no-repeat;

    div {
        position: absolute;
        top: -150%;
        left: -150%;
        width: 200%;
        height: 200%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 1), transparent);
        animation-name: shimmer;
        animation-duration: 8s;
        animation-iteration-count: infinite;
        opacity: 0.5;
        transform: rotate(45deg);
    }

    @keyframes shimmer {
        0% {
            top: -150%;
            left: -150%;
        }
        100% {
            top: 1000%;
            left: 1000%;
        }
    }

    // Hide when parent has stop-all-animations class
    // This prevents Safari canvas tainting from mask-image CSS property
    :global(.stop-all-animations) & {
        display: none !important;
    }
}
